module.exports = __webpack_public_path__ + "img/faceStandard.beb195de.jpg";